angular
  .module("accordionDatiClienteDigital.components", [])
  .component("accordionDatiClienteDigital", {
    templateUrl:
      "ng/components/accordionDatiClienteDigital/accordionDatiClienteDigital.view.html",
    bindings: {
      //utils
      containerClass: "@",
      riUserG: "<",
      //this outputs: 
      //result as 'true' or 'false'
      //datiCliente as 'riUserG
      onRiUserChanges: "&?",
      onSedeChanges: "&?",
      showHeadquarters: "@"
    },
    controllerAs: "ClientDataDigitalCtrl",
    controller: ControllerDatiClienteDigital
  });

function ControllerDatiClienteDigital(RiUserG, $typeDomainService) {
  var self = this;

  self.model = {
    loading: {
      sae: false,
      rae: false,
      giuridicForm: false
    },
    disabled: {
      rae: true
    },
    dropdown: {
      customerNatures: [],
      legalStatuses: [],
      sae: [],
      rae: []
    },
    populated: false
  };

  self.$onInit = function() {
    /**
     * Instantiate the model
     * 1. it could come from a prepopulated model
     * 2. it could come from an empty model (next or back from wf..)
     */
    self.model.riUserG = RiUserG.build(self.riUserG);

    /** Set the populated flag to true if there's an incoming model */
    if (self.riUserG && self.riUserG.piva) {
      self.model.populated = true;
    }

    self.fieldChanges();

    self.getAllLegalStatuses();
  };

  self.getAllLegalStatuses = function() {
    self.model.loading.giuridicForm = true;

    $typeDomainService
      .getAllLegalStatuses()
      .then(function(legalStatuses) {
        self.model.dropdown.legalStatuses = legalStatuses;
      })
      .finally(function() {
        self.model.loading.giuridicForm = false;
      });
  };

  self.getSaeByLegalStatus = function(legalStatus) {
    self.model.loading.sae = true;

    $typeDomainService
      .getSaeByLegalStatus(legalStatus)
      .then(function(saeList) {
        self.model.dropdown.sae = saeList;
      })
      .finally(function() {
        self.model.loading.sae = false;
      });
  };

  self.getRaeBySae = function(sae) {
    self.model.loading.rae = true;

    $typeDomainService
      .getRaeBySae(sae)
      .then(function(raeList) {
        self.model.dropdown.rae = raeList;

        //Prevalorizzazione del singolo risultato
        if (raeList && raeList.length <= 1) {
          self.model.riUserG.rae = raeList.pop();
        }

        //Disabilitare se c'è un solo risultato
        if (raeList && raeList.length === 1) {
          self.model.disabled.rae = true;
        } else {
          self.model.disabled.rae = false;
        }
      })
      .finally(function() {
        self.model.loading.rae = false;
      });
  };

  self.fieldChanges = function(name, value, result){
    //update the model and output it
    self.model.riUserG[name] = value;

    //check it for validity
    var info = self.model.riUserG.isOk();
    
    //fieldChanges('sedeLegale', model, result)
    self.onRiUserChanges({ datiCliente: self.model.riUserG, result: info });

  }

}
